import { observable, toJS, flow, action } from "mobx";
import {
	getSiteSelections,
	createSiteSelection,
	renameSiteSelection,
	deleteSiteSelections
} from "services/siteselections";
import { registerHandler, delay } from "services/api";
import { message } from "antd";
import _ from "lodash";

export default class SiteSelectionsStore {	
	constructor() {
		this.siteSelections = observable.array([]);
		this.ui = this.getUI();
	}

	getUI = () => {
		let ui = {
			loadingSiteSelections: false,
			addEditSiteSelectionDialogVisible: false,
			editedSiteSelection: null, //When editedSiteSelection is not null, it means that we are editing that site selection
			renamingSiteSelection: false,
			deletingSiteSelections: false,
			creatingSiteSelection: false
		};
		return observable.object(ui);
	};

	@action
	showAddSiteSelectionDialog = () => {
		this.ui.addEditSiteSelectionDialogVisible = true;
		this.ui.editedSiteSelection = null;
	};

	@action
	hideAddEditSiteSelectionDialog = () => {
		this.ui.addEditSiteSelectionDialogVisible = false;
		this.ui.editedSiteSelection = null;
	};

	@action
	showEditSiteSelectionDialog = siteSelection => {
		this.ui.addEditSiteSelectionDialogVisible = true;
		this.ui.editedSiteSelection = siteSelection;
	};

	@action
	hideEditSiteSelectionDialog = () => {
		this.ui.addEditSiteSelectionDialogVisible = false;
		this.ui.editedSiteSelection = null;
	};

	createSiteSelection = flow(function*(name) {
		this.ui.creatingSiteSelection = true;
		const response = yield createSiteSelection(name);
		this.ui.creatingSiteSelection = false;

		if (response == null) {
			message.error("Failed to create new site selection. Unknown error", 3);
			return;
		}

		if (response.error) {
			message.error(response.error.message, 3);
			return;
		}

		message.success("Successfully created a new site selection", 3);
		this.ui.addEditSiteSelectionDialogVisible = false;
		this.ui.editedSiteSelection = null;
	});

	remoteRenameSiteSelection = flow(function*(siteSelection) {
		this.ui.renamingSiteSelection = true;
		const response = yield renameSiteSelection(siteSelection);
		this.ui.renamingSiteSelection = false;
		if (response == null) {
			message.error("Failed to rename the site selection. Unknown error", 3);
			return;
		}
		if (response.error) {
			message.error(response.error.message, 3);
			return;
		}

		message.success("Successfully rename the site selection", 3);
		this.ui.addEditSiteSelectionDialogVisible = false;
		this.ui.editedSiteSelection = null;
	});

	@action
	renameSiteSelection = siteSelection => {
		const foundIndex = this.siteSelections.findIndex(el => {
			return el.id == siteSelection.id;
		});

		if (foundIndex != -1) {
			this.siteSelections[foundIndex].name = siteSelection.name;
		}
	};

	remoteDeleteSiteSelections = flow(function*(ids) {
		this.ui.deletingSiteSelections = true;
		const response = yield deleteSiteSelections(ids);
		this.ui.deletingSiteSelections = false;
		if (response == null) {
			message.error("Failed to delete selected site selections. Unknown error", 3);
			return;
		}
		if (response.error) {
			message.error(response.error.message, 3);
			return;
		}

		message.success("Successfully deleted selected site selections", 3);
	});

	@action
	deleteSiteSelections = ids => {
		_.remove(this.siteSelections, siteSelection => {
			return ids.includes(siteSelection.id);
		});
	};

	@action
	addSiteSelection = siteSelection => {
		this.siteSelections.push(siteSelection);
	};

	loadSiteSelections = flow(function*() {
		this.ui = this.getUI();
		this.ui.loadingSiteSelections = true;
		const response = yield getSiteSelections();
		this.ui.loadingSiteSelections = false;
		if (response == null) {
			message.error("Failed to load site selections. Unexpected error", 3);
			return;
		}
		if (response.error) {
			message.error(response.error.message, 3);
			return;
		}
		this.siteSelections = observable.array(response.site_selections);

		registerHandler([
			{
				path: "site_selections",
				handler: (err, msg) => {
					if (err != null) return;
					const obj = JSON.parse(msg.body);
					if (obj.action == "addNew") {
                        var siteSelection = obj.siteSelection;                        
						this.addSiteSelection(siteSelection);
						return;
					}

					if (obj.action == "edited") {
						var siteSelection = obj.siteSelection;
						this.renameSiteSelection({
							name: siteSelection.name,
							id: siteSelection.id							
						});
						return;
					}

					if (obj.action == "deleted") {
						this.deleteSiteSelections(obj.ids);
						return;
					}
				}
			}
		]);
	});
}
